import type { FC } from 'react';
import { LessonSection } from '@/Module/Lesson/Component';
import type { ILessonSection } from '@/Module/Lesson/Model/DataModel';
interface IHomePageSectionLessonTabListProps {
  ids: ILessonSection['id'][];
  activeId: number;
}
const HomePageSectionLessonTabList: FC<IHomePageSectionLessonTabListProps> = ({
  activeId,
  ids
}) => {
  return <div className="flex flex-col gap-6 sm:min-h-[400px] md:flex-row md:gap-0 lg:min-h-[500px]" data-sentry-component="HomePageSectionLessonTabList" data-sentry-source-file="HomePageSectionLessonTabList.tsx">
      <div className="md:min-w-[70%] xl:min-w-[68%] ">
        <LessonSection id={ids[0]} categoryCategoryId={activeId} key={ids[0]} index={1} isSummary isRandom className="" imageSize={1036} data-sentry-element="LessonSection" data-sentry-source-file="HomePageSectionLessonTabList.tsx" />
      </div>
      <div className="grid grid-cols-1 gap-4 md:mr-[5%]">
        <LessonSection id={ids[1]} categoryCategoryId={activeId} key={ids[1]} index={2} isSummary isRandom className="" imageSize={406} data-sentry-element="LessonSection" data-sentry-source-file="HomePageSectionLessonTabList.tsx" />
        <LessonSection id={ids[2]} categoryCategoryId={activeId} key={ids[2]} index={3} isSummary isRandom className="" imageSize={406} data-sentry-element="LessonSection" data-sentry-source-file="HomePageSectionLessonTabList.tsx" />
      </div>
    </div>;
};
export default HomePageSectionLessonTabList;